// src/hooks/useFacturacionDisponible.ts
import { useState, useEffect } from 'react';
import { ConfiguracionFacturasApi } from '../services/api/ConfiguracionFacturasApi';

export const useFacturacionDisponible = () => {
  const [disponible, setDisponible] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const verificarFacturacion = async () => {
    try {
      const config = await ConfiguracionFacturasApi.obtenerConfiguracion();
      setDisponible(config.NumeroActual < config.NumeroFin);
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Error al verificar facturación');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificarFacturacion();

    // Verificar cada 5 minutos
    const interval = setInterval(verificarFacturacion, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return { disponible, loading, error };
};